import MarkerProps from './MarkerProps'

export default {
    name: 'kendo-map-marker',
    render () {
        return null
    },
    mixins: [MarkerProps]
}


// WEBPACK FOOTER //
// ./packages/kendo-map-vue-wrapper/src/KendoMapMarker/index.js